export const NAME = 'userSearch';

export const dialogError = 'userSearch/resultLimit';
